import React from 'react';

import { ContentType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { Flex } from 'components/Atoms/Flex/Flex';
import { Spacer } from 'components/Atoms/Spacer/Spacer';
import { ImageBoss } from 'components/Content/Atoms/ImageBoss';
import { ContentContainer } from 'components/Content/Atoms/ContentContainer';
import styles from './Quote.module.scss';

interface Props {
  content: ContentType;
}
export function Quote(props: Props) {
  const { content } = props;
  const { getMediaItem, getImageCrop, translate } = useGetContentTranslations();
  const mediaItem = getMediaItem(content, 0);
  const image = mediaItem?.url;
  const imageCrop = getImageCrop(content, 0);
  const quote = translate(content.translations, 'text');
  const name = translate(content.translations, 'name');
  const title = translate(content.translations, 'title');
  return (
    <ContentContainer content={content}>
      <div className={styles.container}>
        <Flex flexDirection="row">{quote && <div className={styles.quote}>&quot;{quote}&quot;</div>}</Flex>
        <Spacer orientation="vertical" size="small" />
        <Flex flexDirection="row" alignItems="center" gap={16}>
          <>
            {image && <ImageBoss url={image} alt={name} width={86} className={styles.photo} imageCrop={imageCrop} />}
            <Flex flexDirection="column">
              <div className={styles.name}>{name}</div>
              {title && <div>{title}</div>}
            </Flex>
          </>
        </Flex>
      </div>
    </ContentContainer>
  );
}
